/* eslint-disable no-restricted-syntax -- 全站唯一允許直接碰 localStorage 的地方 */
import { logError } from './logger';

/** isAvailable() 探測用的 key，寫完立刻刪掉。 */
const PROBE_KEY = 'convo.storage_probe';

/**
 * localStorage 在 Safari 無痕模式、被封鎖 cookie 的 iframe 內都會直接 throw，
 * 因此一律走這層 wrapper，失敗時降級成「讀不到值」而不是讓 UI 掛掉。
 */
export const storage = {
  get(key: string): string | null {
    try {
      return window.localStorage.getItem(key);
    } catch (error) {
      logError('localStorage.getItem failed', error, { key });
      return null;
    }
  },

  set(key: string, value: string): boolean {
    try {
      window.localStorage.setItem(key, value);
      return true;
    } catch (error) {
      logError('localStorage.setItem failed', error, { key });
      return false;
    }
  },

  remove(key: string): void {
    try {
      window.localStorage.removeItem(key);
    } catch (error) {
      logError('localStorage.removeItem failed', error, { key });
    }
  },

  /**
   * localStorage 整個不能用，跟「這個 key 沒有值」是兩件事——`get()` 兩種情況都回 null。
   *
   * 拿「有沒有值」當判斷依據的呼叫端（例如「這台瀏覽器有沒有 session」）必須先問這個，
   * 不然在 Safari 無痕那類環境會把「讀不到」誤判成「沒有」。
   */
  isAvailable(): boolean {
    try {
      window.localStorage.setItem(PROBE_KEY, '1');
      window.localStorage.removeItem(PROBE_KEY);
      return true;
    } catch {
      return false;
    }
  },
};
